module.exports = __webpack_public_path__ + "media/images/cancel-on-4802503955ea2cc32156ad538e3c1f53.png";